import { Component } from '@angular/core';
import { AccountCenterTableRow } from '../../../classes/account-center/AccountCenterTableRow';
import { ActionType } from '../../../classes/account-center/ActionType';
import { ModalService } from '../../../services/modal/modal.service';
import { ActionItemInterface } from '../../../interfaces/account-center/ActionItemInterface';
import { ModalActionItemInterface } from '../../../interfaces/account-center/ModalActionItemInterface';
import { ModalType } from '../../../../js/interfaces/CoverpathTypes';

@Component({
  selector: 'account-center-table',
  moduleId: module.id,
  templateUrl: './account-center-table.component.html',
})
export class AccountCenterTable {
  rows: Array<AccountCenterTableRow>;
  isJointApp: boolean = false;
  title: string;
  isLoading: boolean = false;
  alert: {
    intent: string;
    text: string;
  };

  //set to true in cases where the table should not be displayed (e.g., when there is a fatal error in getting data)
  hideTable = false;

  actionType: { [s: number]: string } = ActionType;

  constructor(private modalService: ModalService) {}

  getClasses() {
    return {
      'account-center-table': true,
      'joint-app-table': this.isJointApp,
    };
  }

  handleAction(actionItem: ActionItemInterface): void {
    if (actionItem && actionItem.actionType === ActionType.OpenWindow) {
      window.open(actionItem.action);
    }
    if (actionItem && actionItem.actionType === ActionType.Method) {
      actionItem.method();
    }
    if (actionItem && actionItem.actionType === ActionType.OpenModal) {
      if (this.instanceOfModalActionItem(actionItem)) {
        this.modalService.activate({
          type: ModalType[actionItem.action],
          modalData: actionItem.modalData,
        });
      } else {
        this.modalService.activate({
          type: ModalType[actionItem.action],
        });
      }
    }
  }

  instanceOfModalActionItem(actionItem: object): actionItem is ModalActionItemInterface {
    return 'modalData' in actionItem;
  }
}
